// Pure sun-sign helpers. Shared by the frontend (the prediction picker's default sign),
// the server (a fallback when the client sends a chart but no sign), and the fast gate.
// A sun-sign horoscope needs ONLY the sign, so deriving it from the birth DATE costs no
// API call. On a cusp birthday the member can change the sign in the picker: the reading
// is sign-scoped, not chart-scoped, so this never touches a real chart reading's accuracy.

export const ZODIAC_SIGNS = [
  "aries", "taurus", "gemini", "cancer", "leo", "virgo",
  "libra", "scorpio", "sagittarius", "capricorn", "aquarius", "pisces",
];

// The sign already running at the START of each month (index 0 = January).
const SIGN_STARTING_MONTH = [
  "capricorn", "aquarius", "pisces", "aries", "taurus", "gemini",
  "cancer", "leo", "virgo", "libra", "scorpio", "sagittarius",
];
// The day each month's NEW sign takes over (Jan 20 = Aquarius, Feb 19 = Pisces, ...).
const SIGN_CUTOFF_DAY = [20, 19, 21, 20, 21, 21, 23, 23, 23, 23, 22, 22];

// "1985-06-14" -> "gemini". Returns "" when the date is not usable.
export function sunSignFromBirthDate(birthDate) {
  const [, month, day] = String(birthDate || "").split("-").map(Number);
  if (!month || !day || month < 1 || month > 12) return "";
  return day < SIGN_CUTOFF_DAY[month - 1]
    ? SIGN_STARTING_MONTH[month - 1]
    : SIGN_STARTING_MONTH[month % 12];
}

export function signLabel(sign) {
  const s = String(sign || "");
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : "";
}
